const {
  wrapWithIterableIterator
} = require('../../internal/iterable.js');

const {
  nullableWrap: __wrap
} = require('../../internal/wrap.js');

exports.__wrap = __wrap;
const wrap = /*#__PURE__*/wrapWithIterableIterator(__wrap);
exports.wrap = wrap;